import {
  takeLatest,
  call,
  put,
} from 'redux-saga/effects';

import types from './types';
import actions from './actions';
import { getCareersList } from '../api';

export function* getDataFlow() {
  try {
    const response = yield call(getCareersList);

    yield put(
      actions.careerListSucceeded(response.data),
    );
  } catch (error) {
    yield put(
      actions.careerListFailed(
        error,
      ),
    );
  }
}

export function* watchGetLatestCareersList() {
  yield takeLatest(
    types.CAREER_LIST_REQUESTED,
    getDataFlow,
  );
}
export default [
  watchGetLatestCareersList(),
];
